const camelcaseKeysDeep = require('camelcase-keys-deep');

export class Diagnosis {
  code: string;
  name: string;
  displayName: string;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);
    if (data && typeof data === 'object' && data instanceof Array) {
      this.code = data[0];
      this.name = data[1];
    } else if (data && typeof data === 'object') {
      this.code = data.code;
      this.name = data.name;
    }

    if (this.name && this.code) {
      this.displayName = this.name + ' | Code: ' + this.code;
    } else if (this.name) {
      this.displayName = this.name;
    } else {
      this.displayName = this.code;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/diagnoses/diagnosis.ts